var _Defs, _G;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Defs, Rect, G, Mask, Use, Path } from "react-native-svg";
function SvgIconRtmp(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40
  }, props), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(Rect, {
    id: "icon-rtmp_svg__a",
    width: 40,
    height: 40,
    x: 0,
    y: 0,
    rx: 10
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement(Mask, {
    id: "icon-rtmp_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#icon-rtmp_svg__a"
  })), /*#__PURE__*/React.createElement(Use, {
    fill: "#00245A",
    xlinkHref: "#icon-rtmp_svg__a"
  }), /*#__PURE__*/React.createElement(G, {
    mask: "url(#icon-rtmp_svg__b)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M24.708 28.904h2.203a2.835 2.835 0 002.835-2.835V14.584a2.835 2.835 0 00-2.835-2.834H14.707a2.835 2.835 0 00-2.834 2.834v1.485"
  }), /*#__PURE__*/React.createElement(Path, {
    stroke: "#17BF88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M24.708 28.904h2.203a2.835 2.835 0 002.835-2.835V14.584a2.835 2.835 0 00-2.835-2.834H14.707a2.835 2.835 0 00-2.834 2.834v1.485"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: "#17BF88",
    d: "M11.396 29.178a1.276 1.276 0 001.804-1.803 1.278 1.278 0 00-1.804 0 1.277 1.277 0 000 1.803"
  }), /*#__PURE__*/React.createElement(Path, {
    stroke: "#17BF88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M20.87 28.825c0-2.334-.89-4.668-2.672-6.45a9.09 9.09 0 00-6.448-2.67m5.433 9.12c0-1.391-.53-2.781-1.591-3.842a5.418 5.418 0 00-3.842-1.591"
  })))));
}
export default SvgIconRtmp;